import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { SignalrService } from 'src/app/services/signalr.service';
import { environment } from 'src/environments/environment';
import { MatSelect } from '@angular/material/select';
import { FormControl } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';

import * as UAParser from '../../../assets/ua-parser.js';
import { conditionallyCreateMapObjectLiteral } from '@angular/compiler/src/render3/view/util';
import { Message } from '@angular/compiler/src/i18n/i18n_ast';
//declare const UAParser: any;

export interface Option {
  value: string;
  display: string;
}

export interface Img {
  src: string;
  name: string;
}


@Component({
  selector: 'app-host',
  templateUrl: './host.component.html',
  styleUrls: ['./host.component.scss']
})


export class HostComponent implements OnInit, OnDestroy {

  @ViewChild('localVideo') localVideo: ElementRef;
  @ViewChild('remoteVideo') remoteVideo: ElementRef;
  @ViewChild('canvas', { static: true }) canvas: ElementRef<HTMLCanvasElement>;

  localStream: MediaStream;
  remoteStream: MediaStream;

  username: string = '';
  userID: string = '';
  userFullName: string = '';
  idValuation: string = '';

  room: string;
  clientUrl: string = '';
  mobileNr: string = '';
  clientGEO: string = '';
  peerConnection: RTCPeerConnection;

  isInitiator: boolean;
  isChannelReady: boolean;
  isStarted: boolean;
  isSMSSent: boolean = false;


  selectedCamValue: string = '0';
  camArray: Option[] = [
    { value: '0', display: '- Izberi kamero -' },
  ];

  selectedZoomValue: string = '640x360';
  zoomArray: Option[] = [
    { value: '0', display: '- Izberi velikost -' },
    { value: '320x180', display: '320 x 180' },
    { value: '640x360', display: '640 x 360' },
    { value: '640x480', display: '640 x 480' },
    { value: '768x432', display: '768 x 432' },
  //  { value: '768x576', display: '768 x 576' },
    // { value: '1024x576', display: '1024 x 576' },
  ];

  selectedImgLocation: string = 'naNamizje';

  infoInputText: string = '';
  infoFullText: string = '';

  imgArray: Img[] = [];

  Logs: Array<string> = [];


  constructor(
    private snack: MatSnackBar,
    private route: ActivatedRoute,
    private signaling: SignalrService, 
  ) {

    this.route.paramMap.subscribe(async param => {
      this.room = param['params']['room'];

      if (this.room && this.room != '1')
        console.log('Soba iz URLja ' + this.room);
      else {
        this.room = Math.floor(Math.random() * 100000).toString();
        console.log('Soba rand  ' + this.room);
      }

    //  console.log('url ID');
      console.log(param['params']['id']);
      let login = true;
      if (param['params']['id']) {
        let vok = decodeURIComponent(window.atob(param['params']['id']));
        let voks = vok.split(';');
        if (voks.length == 7) {

          this.username = voks[1];
          this.userFullName = voks[2];
          this.userID = voks[3];
          this.idValuation = voks[4];

          if (Number(new Date()) - parseInt(voks[6]) < 10000) login = false;

          if (voks[5].length == 9) this.mobileNr = voks[5];

        }
        console.log(vok);
      }

      if (login) {
        while (prompt("Vnesite ključ:", "") != 'matest') {
          alert('Ključ ni veljaven!');
        }
      }


    });

    /*this.route.paramMap.subscribe(async param => {
      this.room = param['params']['room'];
    });*/
  /*  this.route..subscribe(async param => {
      this.room = param.
    });
    this.clientUrl = this.route.toString();
    */
  //  console.log(route.url);
  }
  takeClientPic(): void {
    this.sendMessage('takePic');
  }

 
  takeClientPic2(): void {

    var context = this.canvas.nativeElement.getContext('2d');
   
    let height = this.remoteVideo.nativeElement.videoHeight //this.remoteStream.getVideoTracks()[0].getSettings().height;
    let width = this.remoteVideo.nativeElement.videoWidth //this.remoteStream.getVideoTracks()[0].getSettings().width;

    this.canvas.nativeElement.width = width;
    this.canvas.nativeElement.height = height;
    context.drawImage(this.remoteVideo.nativeElement, 0, 0, width, height);
    console.log('ok');

    let imgUrl = this.canvas.nativeElement.toDataURL('image/jpeg', 1.0)

    this.downloadURI(imgUrl, this.room + 'Local.jpg');
  }

  getClientGEO(): void {
    this.sendMessage('getGeolocation');
  }

  sendSMS(): void {
    if (!this.mobileNr || this.mobileNr.length < 5) {
      this.snack.open('Neustrezna mobilna številka', 'Napaka', { duration: 3000, verticalPosition: "top" });
      return;
    }
    console.log('SendSMS1');
    this.signaling.invoke('SendSMS', this.room, this.mobileNr, window.location.href);
    console.log('SendSMS2');
    this.isSMSSent = true;
   // document.getElementById('inputGsm').readOnly = true;
    document.getElementById('inputGsm').style.color = "#8B8B8B";
  }

  displayInfoInputText(): void {
    alert(this.infoFullText);
  }

  copyToClipboard(item, showBox): void {
    let listener = (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', (item));
      e.preventDefault();
    };

    document.addEventListener('copy', listener);
    document.execCommand('copy');
    document.removeEventListener('copy', listener);

    if (showBox == true) {
      this.snack.open('Kopiran!', 'OK', { duration: 700, verticalPosition: "top" });
    }
  }

  downloadURI(dataURl, name): void {

    //var img = document.createElement("img");
    //img.src = dataURl;
    //document.getElementById("gallery").appendChild(img);

    this.imgArray.unshift({ src: dataURl, name: name });

    if (this.selectedImgLocation == 'naNamizje') {
      let link = document.createElement("a");
      link.download = name;
      link.href = dataURl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
   
  }


  downloadImg(id, name): void {
    let app = this;
    const xhttp = new XMLHttpRequest();
    xhttp.onload = function () {

      //console.log("xhttp.responseText = " + this.responseText);
      console.log("xhttp.responseText.length = " + this.responseText.length);
      app.downloadURI(this.responseText, name);


    }
    xhttp.open("GET", environment.signalingServerUrl + "/uploadFile/" + this.room + "/" + id);
    xhttp.send();


   

  }

  downloadText(filename, text): void {
    var element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  }

  showLogs(): void {

    this.downloadText("LOG" + this.room + '.txt', this.Logs.join("\n\r"));
   // this.copyToClipboard(this.Logs.join("\n\r"), false);
    this.snack.open('LOG je kopiran v odložišče!', 'OK', { duration: 700, verticalPosition: "top" });
   // alert(this.Logs.join("\n\r"));
  }

  ngOnInit(): void {
    
    let current_log = console.log;
    console.log = msg => {
      //if (msg !== undefined) this.data.push(msg);

      var currentdate = new Date();
      var datetime = currentdate.getFullYear() + "-" + currentdate.getMonth()
        + "-" + currentdate.getDay() + " "
        + currentdate.getHours() + ":"
        + currentdate.getMinutes() + ":" + currentdate.getSeconds();

      current_log(msg);
      this.Logs.push(datetime + '  ' + msg);
     // current_log.apply(null, arguments);
    }
  

 //   console.log(this.router.url);
   // console.log(window.location.href);
   
   // this.clientUrl = this.route.url.toPromise;
  //  this.pdata = { clientUrl: '', mobileNr: '' };

    /*if (window.opener != null && !window.opener.closed) {
      alert('je!');
    }
    */


    this.signaling.connect('/auth', false).then(() => {
      if (this.signaling.isConnected()) {
        this.signaling.invoke('Authorize').then((token: string) => {
          if (token) {
            sessionStorage.setItem('token', token);
            this.start();

           // this.clientUrl = window.location.href.replace('/host',  '/'+this.room);
            this.clientUrl = window.location.href.substr(0, window.location.href.indexOf('/host')) + '/' + this.room;

         //   this.pdata.clientUrl = "test 887789";
           // this.pdata = { clientUrl: 'test 12345', mobileNr: '' };

          }
        });
      }
    });
    
  }

  start(): void {
    // #1 connect to signaling server
    this.signaling.connect('/signaling', true).then(() => {
      if (this.signaling.isConnected()) {
        this.signaling.invoke('CreateOrJoinRoom', this.room);
      }
    });

    // #2 define signaling communication
    this.defineSignaling();

    // #3 get media from current client
    this.getUserMedia();
  }

  defineSignaling(): void {

    this.signaling.define('snackLog', (message: any, duration: number) => {
      console.log(message);
      this.snack.open(message, 'OK', { duration: duration, verticalPosition: "top" });
    });

    this.signaling.define('log', (message: any) => {
      console.log(message);
    });

    this.signaling.define('created', () => {
      this.isInitiator = true;
    });

    this.signaling.define('joined', () => {
      this.isChannelReady = true;
    });

    this.signaling.define('message', (message: any) => {
      if (message === 'got user media') {
        this.initiateCall();

      } else if (message.type === 'offer') {
        if (!this.isStarted) {
          this.initiateCall();
        }
        this.peerConnection.setRemoteDescription(new RTCSessionDescription(message));
        this.sendAnswer();

      } else if (message.type === 'answer' && this.isStarted) {
        this.peerConnection.setRemoteDescription(new RTCSessionDescription(message));

      } else if (message.type === 'candidate' && this.isStarted) {
        this.addIceCandidate(message);

      } else if (message === 'bye' && this.isStarted) {
        this.handleRemoteHangup();

      } else if (message.type === 'clientGEO') {

        this.showClientGEO(message);

      } else if (message.type === 'myPic') { 

        this.downloadImg(message.id, this.room + 'Img.jpg')

      } else if (message.type === 'clientVolume') {

        if (message.volume) {
          this.infoFullText += 'Glasnost: ' + message.volume * 100 + '% \n';
        }
        else
          console.log('ne dobim glasnosti.');

        if (message.snackMessage) {
          this.snack.open(message.snackMessage, 'OK', { duration: 700, verticalPosition: "top" });
        }

      } else if (message.type === 'clientUserAgent') {

        console.log('clientUserAgent:')
        // console.log(message.value);
        console.log(message.value);
        var pRes = new UAParser(message.value).getResult();
       
        console.log('user device:');
        console.log(pRes);
        console.log(pRes.os.name);
        console.log(pRes.os.version);
        console.log(pRes.browser.name);
        console.log(pRes.browser.version);
        console.log(pRes.device.model);
        console.log(pRes.device.type);
        console.log(pRes.device.vendor);

        this.infoInputText = pRes.os.name + '  ' + pRes.os.version;

        this.infoFullText += pRes.os.name + '   ' + pRes.os.version + '\n';
        this.infoFullText += pRes.browser.name + '   ' + pRes.browser.version + '\n';
        if (pRes.engine.name) this.infoFullText += pRes.engine.name + '   ' + pRes.engine.version + '\n';
        if (pRes.device.type) this.infoFullText += pRes.device.model + '   ' + pRes.device.type + '   ' + pRes.device.vendor + '\n';



        /*

        this.infoInputText = 'os.name: ' + pRes.os.name;
        this.infoInputText += 'os.version: ' + pRes.os.version;
        this.infoInputText += 'browser.name: ' + pRes.browser.name;
        this.infoInputText += 'browser.version: ' + pRes.browser.version;
        this.infoInputText += 'device.model: ' + pRes.device.model;
        this.infoInputText += 'device.type: ' + pRes.device.type;
        this.infoInputText += 'device.vendor: ' + pRes.device.vendor;

*/




      } else if (message.type === 'clientEnumerateDevices') {

        console.log('got clientEnumerateDevices');
        console.log(message.devices);

        this.camArray = [{ value: '0', display: '- Izberi kamero -' }];

        message.devices.forEach((cam) => {
          console.log(cam.label + ' x ' + cam.deviceId);
          this.camArray.push({ value: cam.deviceId, display: cam.label });
        });
      }
     
    });
  }

  increaseClientVolume(volValue): void {
    this.sendMessage({ type: 'increaseClientVolume', volValue: volValue });
  }

  onChangeCam(): void {
    console.log('selectedCam=' + this.selectedCamValue);
    console.log('selectedzoomCam=' + this.selectedZoomValue);

    if (this.selectedZoomValue.split('x').length === 2)
      this.sendMessage({ type: 'changeCam', deviceId: this.selectedCamValue, size: { width: parseInt(this.selectedZoomValue.split('x')[0]), height: parseInt(this.selectedZoomValue.split('x')[1]) } });
    else
      this.sendMessage({ type: 'changeCam', deviceId: this.selectedCamValue });

  }

  imgUrlToDataUrl(url): void {
      //fetch(url)
      //.then((response) => {
      //  return response.blob();
      //}).then(blob => {


      //  this.downloadURI(URL.createObjectURL(blob), 'geolokacija.jpg');
      //});
    let app = this;
    const img = new Image();
    img.setAttribute('crossOrigin', 'anonymous');
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      const dataURL = canvas.toDataURL('image/jpeg', 1.0);
      app.downloadURI(dataURL, this.room + 'Geo.jpg');
      //console.log(dataURL)
    }
    img.src = url
    
  }

  showClientGEO(crd): void {

    if (crd == null) console.log('null je');

    console.log(`Latitude : ${crd.latitude}`);
    console.log(`Longitude: ${crd.longitude}`);
    console.log(`More or less ${crd.accuracy} meters.`);


    this.clientGEO = crd.latitude + ',' + crd.longitude; //+ '     nasančnost: ' + crd.accuracy + ' metrov';

    const geoUrl = 'https://maps.googleapis.com/maps/api/staticmap?key=AIzaSyA0urFfHkD7qMZzCjPFHmxxnz_p-8z83EI&center=' + crd.latitude + ',' + crd.longitude + '&zoom=13&size=640x480&&sensor=false&maptype=roadmap&markers=' + crd.latitude + ',' + crd.longitude;
    this.imgUrlToDataUrl(geoUrl);
  }

  getUserMedia(): void {
    navigator.mediaDevices.getUserMedia({
      audio: true,
     // video: true
    })
    .then((stream: MediaStream) => {
      this.addLocalStream(stream);
      this.sendMessage('got user media');
      if (this.isInitiator) {
        this.initiateCall();
      }
    })
    .catch((e) => {
      alert('getUserMedia() error: ' + e.name + ': ' + e.message);
    });
  }

  initiateCall(): void {
    console.log('Initiating a call.');

    if (this.isStarted) {
      //ubi ubi
      this.stopPeerConnection();
      this.isChannelReady = true;
    }

    //if (!this.isStarted && this.localStream && this.isChannelReady) {
    if ( this.localStream && this.isChannelReady) {

      this.createPeerConnection();

     // this.peerConnection.addTrack(this.localStream.getVideoTracks()[0], this.localStream);
      this.peerConnection.addTrack(this.localStream.getAudioTracks()[0], this.localStream);

      this.isStarted = true;
      if (this.isInitiator) {
        this.sendOffer();
      }
    }
  }

  createPeerConnection(): void {
    console.log('Creating peer connection.');
    try {
      this.peerConnection = new RTCPeerConnection({
        iceServers: environment.iceServers,
        sdpSemantics: 'unified-plan'
      } as RTCConfiguration);

      this.peerConnection.onicecandidate = (event: RTCPeerConnectionIceEvent) => {
        if (event.candidate) {
          this.sendIceCandidate(event);
        } else {
          console.log('End of candidates.');
        }
      };

      this.peerConnection.ontrack = (event: RTCTrackEvent) => {
        if (event.streams[0]) {
          this.addRemoteStream(event.streams[0]);
        }
      };
    } catch (e) {
      console.log('Failed to create PeerConnection.', e.message);
      return;
    }
  }

  sendOffer(): void {
    console.log('Sending offer to peer.');
    this.addTransceivers();
    this.peerConnection.createOffer()
    .then((sdp: RTCSessionDescriptionInit) => {
      this.peerConnection.setLocalDescription(sdp);
      this.sendMessage(sdp);
    });
  }

  sendAnswer(): void {
    console.log('Sending answer to peer.');
    this.addTransceivers();
    this.peerConnection.createAnswer().then((sdp: RTCSessionDescription) => {
      this.peerConnection.setLocalDescription(sdp);
      this.sendMessage(sdp);
    });
  }

  addIceCandidate(message: any): void {
    console.log('Adding ice candidate.');
    const candidate = new RTCIceCandidate({
      sdpMLineIndex: message.label,
      candidate: message.candidate
    });
    this.peerConnection.addIceCandidate(candidate);
  }

  sendIceCandidate(event: RTCPeerConnectionIceEvent): void {
    console.log('Sending ice candidate to remote peer.');
    this.sendMessage({
      type: 'candidate',
      label: event.candidate.sdpMLineIndex,
      id: event.candidate.sdpMid,
      candidate: event.candidate.candidate
    });
  }

  sendMessage(message): void {
    this.signaling.invoke('SendMessage', message, this.room);
  }

  addTransceivers(): void {
    console.log('Adding transceivers.');
    const init = { direction: 'recvonly', streams: [], sendEncodings: [] } as RTCRtpTransceiverInit;
    this.peerConnection.addTransceiver('audio', init);
    this.peerConnection.addTransceiver('video', init);
  }

  addLocalStream(stream: MediaStream): void {
    console.log('Local stream added.');
    this.localStream = stream;
    this.localVideo.nativeElement.srcObject = this.localStream;
    this.localVideo.nativeElement.muted = 'muted';
  }

  addRemoteStream(stream: MediaStream): void {
    console.log('Remote stream added.');
    this.remoteStream = stream;
    this.remoteVideo.nativeElement.srcObject = this.remoteStream;
   // this.remoteVideo.nativeElement.muted = 'muted';
  }

  hangup(): void {
    console.log('Hanging up.');
    this.stopPeerConnection();
    this.sendMessage('bye');
    this.signaling.invoke('LeaveRoom', this.room);
    setTimeout(() => {
      this.signaling.disconnect();
    }, 1000);
  }

  handleRemoteHangup(): void {
    console.log('Session terminated by remote peer.');
    this.stopPeerConnection();
    this.isInitiator = true;
    this.snack.open('Remote client has left the call.', 'Dismiss', { duration: 5000 });
  }

  stopPeerConnection(): void {
    this.isStarted = false;
    this.isChannelReady = false;
    if (this.peerConnection) {
      this.peerConnection.close();
      this.peerConnection = null;
    }
  }

  ngOnDestroy(): void {
    this.hangup();
    if (this.localStream && this.localStream.active) {
      this.localStream.getTracks().forEach((track) => { track.stop(); });
    }
    if (this.remoteStream && this.remoteStream.active) {
      this.remoteStream.getTracks().forEach((track) => { track.stop(); });
    }
  }
}
/*
export class PData {
  clientUrl: string;
  mobileNr: string;
}
*/
